// removed by extract-text-webpack-plugin
module.exports = {"modalDownload":"_1ve-2BTy5_qpBijTfQ2_tv","bgRect":"_2g9kBtNg6riqFgpIU1EfVV","bgStars":"_3zE6i-t2ihmld8OuOxk1ty","bgEllipse":"_38Ti352A5ewy21hW4XEI5t","headerImage":"_3PnpeVqvw1VVzQwJ5ZBun0","ctaText":"_2HyJHHUVQU1M3L9X9tWPyw","actionButtons":"FJsBQRC_EpxAS95Q75wkr","btnDownload":"_2MRolx2e-4LRBTMx2bFabi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/DownloadAppPopup.scss
// module id = 1116
// module chunks = 0